import { requestMain, requestBaseService } from './index'
import { convertObjectToQueryString } from '../../utils'

export const getAnalysis = (payload) => {
  const paramtoQuery = convertObjectToQueryString({
    ...payload.params,
    published_on: 'analysis',
  })

  return requestBaseService({
    url: `content/ex/v1/post`,
    method: 'get',
    params: {
      page: payload?.params?.page,
      size: payload?.params?.size,
      sort: 'updated_at desc',
      query: paramtoQuery,
    },
  })
}

export const getAnalysisDetail = (payload) => {
  return requestBaseService({
    url: `content/ex/v1/post/${payload.id}`,
    method: 'get',
  })
}

const Analysis = {
  getAnalysis,
  getAnalysisDetail,
}

export default Analysis
